import { StateNode, TLStateNodeConstructor } from "tldraw"
import { LDOrigin } from "./LDOrigin"

export class LDOriginTool extends StateNode {
  static override id = "origin"
  static override initial = "origin"

  static override isLockable = false
  static override children(): TLStateNodeConstructor[] {
    return [LDOrigin]
  }
}
